import { RouteConfig } from 'vue-router';
import { Home } from '@/pages';

const routeConfig: RouteConfig = {
  path: '/home',
  component: Home
};
export default routeConfig;
